<template>
    <div id="app">
        <FeedbackForm v-if="!submitted"/>
        <AfterSubmitPage v-if="submitted" :number="number"/>
    </div>
</template>

<script>
import {eventBus} from "@/main";
import FeedbackForm from './components/FeedbackForm.vue'
import AfterSubmitPage from './components/AfterSubmitPage.vue'
import {loadLanguageAsync} from "@/i18n";

export default {
    name: 'App',
    components: {
        FeedbackForm: FeedbackForm,
        AfterSubmitPage: AfterSubmitPage
    },
    data: () => ({
        submitted: false,
        number: ''
    }),
    beforeCreate() {
        loadLanguageAsync()
    },
    created() {
        eventBus.$on('formSubmitted', (number) => {
            this.submitted = true;
            this.number = number;
        });
        eventBus.$on('newForm', () => {
            this.submitted = false;
        });
    }
}
</script>

<style>
#app {
    font-family: Arial, Helvetica, sans-serif;
    font-size: 0.938em;
    line-height: 1.428em;
    font-weight: 400;
}
</style>
